import { ALL_DISTRICTS, ALL_DISTRICTS_FLAT } from '@/constants/location_districts';
import { ALL_STATES } from '@/constants/location_states';

const INTERNAL_PREFIX = 'news-in-';

export function toCleanSlug(slug: string): string {
  return slug.startsWith(INTERNAL_PREFIX) ? slug.slice(INTERNAL_PREFIX.length) : slug;
}

export function toInternalStateSlug(stateParam: string): string | undefined {
  if (ALL_STATES[stateParam]) {
    return stateParam;
  }
  const candidate = `${INTERNAL_PREFIX}${stateParam}`;
  if (ALL_STATES[candidate]) {
    return candidate;
  }
  return undefined;
}

export function toInternalDistrictSlug({
  stateInternalSlug,
  districtParam,
}: {
  stateInternalSlug: string;
  districtParam: string;
}): string | undefined {
  const state = ALL_STATES[stateInternalSlug];
  if (!state) {
    return undefined;
  }
  const stateCode = state.value;

  const directDistrict = ALL_DISTRICTS_FLAT[districtParam];
  if (directDistrict && directDistrict.value.startsWith(`${stateCode}_`)) {
    return districtParam;
  }

  const candidate = `${INTERNAL_PREFIX}${districtParam}`;
  const districtByCandidate = ALL_DISTRICTS[stateCode]?.[candidate];
  if (districtByCandidate) {
    return candidate;
  }

  const stateDistricts = ALL_DISTRICTS[stateCode] || {};
  const byClean = Object.keys(stateDistricts).find(
    (internalSlug) => toCleanSlug(internalSlug) === districtParam,
  );
  return byClean;
}
